import gql from 'graphql-tag';

const query = gql`
  query MealDetails($userDietSetId: Int!, $mealType: Int!, $dietMealId: Int!) {
    me {
      id
      dailyDietMeal(userDietSetId: $userDietSetId, mealType: $mealType, dietMealId: $dietMealId) {
        id
        mealType {
          type
          name
        }
        name
        key
        kcal
        preparationVideoUrl
        preparationImageUrl
        canBeAddedToFavorites
        isFavorite
        isEaten
        macro {
          protein {
            grams
            kcal
            percentage
          }
          animalProtein {
            grams
            kcal
            percentage
          }
          fat {
            grams
            kcal
            percentage
          }
          carbohydrates {
            grams
            kcal
            percentage
          }
        }
        preparationTime {
          years
          months
          days
          hours
          minutes
          seconds
        }
        dishes {
          id
          key
          name
          recipe
          recipeNote
          isPortioned
          portions
          portionsTotal
          isFirstOccurrence
          isLastOccurrence
          ingredients {
            key
            productAmountId
            productId
            name
            hasReplacement
            category {
              id
              isSeasoning
              isOptional
              name
            }
            measurements {
              measureId
              amount
              unit
              text
              isBaseUnit
            }
            kcal
            macro {
              protein {
                grams
              }
              fat {
                grams
              }
              carbohydrates {
                grams
              }
            }
            original {
              productId
              name
              measurements {
                amount
                unit
                text
              }
            }
            replacements {
              productId
              name
              measurements {
                amount
                unit
                text
              }
            }
            saleProductVariant {
              link
            }
            note {
              title
              content
              media {
                __typename
                ... on UserDailyDietMealDishIngredientNoteMediaImage {
                  imageUrl
                }
                ... on UserDailyDietMealDishIngredientNoteMediaVideo {
                  posterUrl
                  videoUrl
                }
              }
            }
          }
        }
        diabeticDetails {
          assimilableCarbohydrate
          carbohydrateUnit
          fatProteinUnit
        }
        diabeticDietConfig {
          showCarbohydrateUnit
          showProteinFatUnit
          showAssimilableCarbohydrate
        }
        mealCustomTag {
          label
          color
        }
        rating {
          availableLabels {
            name
          }
          averageRating {
            averageRating
            ratingsCount
          }
          userRating {
            rating
            labels {
              name
            }
          }
        }
      }
    }
  }
`;

export default query;
